import React from "react";
import T from "prop-types";
import { connect } from "react-redux";
import * as actions from "MODULES/Notifications/actions";
import { Icon } from "MODULES/shared/components";

export function MarkRead({ noteId, markRead }) {
  const onClick = e => {
    e.stopPropagation();
    markRead(noteId);
  };

  return (
    <a role="button" className="text-danger" onClick={onClick}>
      <Icon name="close" fixed />
    </a>
  );
}

MarkRead.propTypes = {
  noteId: T.number.isRequired,
  markRead: T.func.isRequired
};

export default connect(undefined, dispatch => ({
  markRead: id => dispatch(actions.markDeleted(id))
}))(MarkRead);



// WEBPACK FOOTER //
// ./app/modules/Notifications/components/Search/MarkRead.jsx